export const purchaseEvent = () => {
  window.fbq("track", "Purchase");
};
